<template>
    <v-card elevation="1" class="pa-6 mt-6">
      <h4 class="mb-4">eRFM (Customer Group)</h4>
      <v-skeleton-loader
        v-if="eRFMInfoLoader"
        type="list-item-three-line, action"
      />
      <template v-else>
        <!-- RFM Group Row -->
        <v-row class="ma-0">
          <v-col cols="4" class="body-2 d-flex align-center grey--text">
            RFM Group
          </v-col>
          <v-col cols="8" class="d-flex align-center">
            <div
              v-if="groupNames[contactScore.rfmGroup]"
              class="icon-section mr-1"
            >
              <v-img
                contain
                :src="getGroupImage(contactScore.rfmGroup)"
                height="24"
                width="24"
                class="mr-2"
              />
            </div>
            <div>{{ groupNames[contactScore.rfmGroup] || 'Unknown' }}</div>
          </v-col>
        </v-row>
        <!-- Engagement Level Row -->
        <v-row class="ma-0">
          <v-col cols="4" class="body-2 d-flex align-center grey--text">
            Engagement Level
          </v-col>
          <v-col cols="8" class="d-flex align-center">
            {{ contactScore.engagement || 'Unknown' }}
          </v-col>
        </v-row>
      </template>
    </v-card>
  </template>
  <script>
  import { $marketingContacts, $erfmReport } from "@core/services";
  export default {
    props: {
      contactId: [Number, String],
    },
    data() {
      return {
        contactScore: {
          engagement: '', // Engagement level of the contact
          rfmGroup: '', // RFM group of the contact
        },
        groupNames: {}, // Object to store RFM group aliases
        eRFMInfoLoader: false,
      };
    },
    mounted() {
      // Fetch the eRFM score and group names when the component is mounted
      this.getERFMScore();
    },
    methods: {
      // Fetch the eRFM score and group names simultaneously
      async getERFMScore() {
        this.eRFMInfoLoader = true;
        try {
          await Promise.all([this.fetchGroupNames(), this.fetchScore()]);
        } finally {
          this.eRFMInfoLoader = false;
        }
      },
      // Fetch group names/aliases for RFM groups
      async fetchGroupNames() {
        const response = await $erfmReport.getGroupAliases();
        this.groupNames = response.data.data || {};
      },
      // Method to fetch the eRFM score for the contactId
      async fetchScore() {
        const response = await $marketingContacts.getERFMScore(this.contactId);
        const { engagement, rfm } = response.data.data;
        // Update the contactScore with the fetched engagement and RFM group
        this.contactScore.engagement = engagement;
        this.contactScore.rfmGroup = rfm;
      },
      // Dynamically get the image path for the RFM group
      getGroupImage(group) {
        return require(`@core/assets/images/erfm/${group}.svg`);
      },
    },
  };
  </script>